import { create } from 'zustand';

interface UiState {
  // Filter state (for Phase 3 browsing UX)
  filters: {
    search: string;
    type: string | null;
    country: string | null;
    rating: number | null;
    age_category: string[];
    tags: string[];
    kid_friendly: boolean | null;
    disability_friendly: boolean | null;
  };
  setFilters: (filters: Partial<UiState['filters']>) => void;
  clearFilters: () => void;
  
  // Modal state
  isFilterModalOpen: boolean;
  openFilterModal: () => void;
  closeFilterModal: () => void;
  
  // Selected items
  selectedPlaceId: string | null;
  setSelectedPlaceId: (id: string | null) => void;
  
  // Map-list sync
  hoveredPlaceId: string | null;
  setHoveredPlaceId: (id: string | null) => void;
  mapCenter: [number, number] | null;
  setMapCenter: (center: [number, number] | null) => void;
}

export const useUiStore = create<UiState>((set) => ({
  filters: {
    search: '',
    type: null,
    country: null,
    rating: null,
    age_category: [],
    tags: [],
    kid_friendly: null,
    disability_friendly: null,
  },
  setFilters: (newFilters) =>
    set((state) => ({
      filters: { ...state.filters, ...newFilters },
    })),
  clearFilters: () =>
    set({
      filters: {
        search: '',
        type: null,
        country: null,
        rating: null,
        age_category: [],
        tags: [],
        kid_friendly: null,
        disability_friendly: null,
      },
    }),
  
  isFilterModalOpen: false,
  openFilterModal: () => set({ isFilterModalOpen: true }),
  closeFilterModal: () => set({ isFilterModalOpen: false }),
  
  selectedPlaceId: null,
  setSelectedPlaceId: (id) => set({ selectedPlaceId: id }),
  
  hoveredPlaceId: null,
  setHoveredPlaceId: (id) => set({ hoveredPlaceId: id }),
  mapCenter: null,
  setMapCenter: (center) => set({ mapCenter: center }),
}));
